import type { AssistantOptions } from "@workleap-ai/shared/types";
import { create } from "zustand";

export type CustomizationOptions = Pick<AssistantOptions, "welcomeMessage" | "welcomeSubtext" | "inputPlaceholder" | "isResizable" | "showDictation">;

interface AssistantOptionsStore {
    options: CustomizationOptions;
    setOptions: (options: Partial<CustomizationOptions>) => void;
    resetOptions: (keys?: Array<keyof AssistantOptions>) => void;
}

const DEFAULT_OPTIONS: CustomizationOptions = {
    welcomeMessage: null,
    welcomeSubtext: null,
    inputPlaceholder: null,
    isResizable: false,
    // undefined = dictation on by default; false = explicit surface opt-out.
    showDictation: undefined
};

export const useAssistantOptionsStore = create<AssistantOptionsStore>(set => ({
    options: { ...DEFAULT_OPTIONS },
    setOptions: (newOptions: Partial<CustomizationOptions>) => {
        set(state => ({
            options: { ...state.options, ...newOptions }
        }));
    },
    resetOptions: (keys?: Array<keyof AssistantOptions>) => {
        const keysToReset = keys || ["welcomeMessage", "welcomeSubtext", "inputPlaceholder", "isResizable", "showDictation"];
        set(state => ({
            options: {
                ...state.options,
                ...Object.fromEntries(
                    keysToReset
                        .filter((key): key is keyof CustomizationOptions => key in DEFAULT_OPTIONS)
                        .map(key => [key, DEFAULT_OPTIONS[key]])
                )
            }
        }));
    }
}));
